// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3E-lu","productName":"Table_productName__mkt7q"};